import Validator from '@/shared/utils/validator'
import { User } from '../user'

async function register(data, networkRepo, localRepo) {
  Validator.requireObject('data', data)
  Validator.require('firstName', data.firstName, 'string')
  Validator.require('lastName', data.lastName, 'string')
  Validator.require('email', data.email, 'string')
  Validator.require('password', data.password, 'string')
  const signupData = {
    email: data.email,
    password: data.password,
    firstName: data.firstName,
    lastName: data.lastName,
    countryCode: data.countryCode || 'BJ',
    metadata: data.metadata || {},
  }
  const user = new User()
  user.setData(signupData)

  const response = await networkRepo.register(user)
  Validator.requireObject(response, data)
  Validator.require('id', response.id, 'string')
  Validator.require('email', response.email, 'string')
  Validator.require('firstName', response.firstName, 'string')
  Validator.require('lastName', response.lastName, 'string')
  Validator.requireObject('metadata', response.metadata ?? {})

  user.setData(response)
  await localRepo.save(user)
  return user
}

export default register
